import { render, staticRenderFns } from "./ModalTransferMoney.vue?vue&type=template&id=79cfdc79&scoped=true"
import script from "./ModalTransferMoney.vue?vue&type=script&lang=js"
export * from "./ModalTransferMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cfdc79",
  null
  
)

export default component.exports